import request from "superagent";

import { getAuthHeader } from "../../../utils/superagent";

// FIXME: Automatically disabled during ESLint config update
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'filter' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchFacilities(filter, project, options: any = {}) {
  options.limit = options.limit || 100000;
  const res = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .post(`${global.api}/facilityprofile/details`)
    .set(await getAuthHeader())
    .send({ filter, project, options });

  return res.body;
}

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'id' implicitly has an 'any' type.
export async function fetchFacility(id, projection) {
  const res = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityprofile/${id}`)
    .set(await getAuthHeader())
    .query({ projection });

  return res.body;
}
